import React from "react";
import { Link } from "react-router-dom";
import styles from "./Promociones.module.css";
import { BlogCover } from "../blog/BlogCard";
import { promoCoverSource, promoStatusBadge, promoStripText } from "./promoUtils";

/** Texto de la franja separado en partes por "|" para pintar el divisor. */
function StripText({ text }) {
  const parts = String(text || "")
    .split("|")
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length === 0) return null;
  return parts.map((part, i) => (
    <React.Fragment key={`${part}-${i}`}>
      {i > 0 && (
        <span className={styles.stripDivider} aria-hidden="true">
          |
        </span>
      )}
      <span className={i === 0 ? styles.stripMain : styles.stripSecondary}>{part}</span>
    </React.Fragment>
  ));
}

/**
 * Tarjeta de promoción / rifa (listado y teaser del home).
 * @param {object} props
 * @param {object} props.promo  Elemento de GET /raffles/
 * @param {"h2"|"h3"} [props.headingLevel]
 */
const PromoCard = ({ promo, headingLevel = "h2" }) => {
  const Heading = headingLevel;
  const href = `/promociones/${encodeURIComponent(promo.slug)}`;
  const badge = promoStatusBadge(promo);
  const strip = promoStripText(promo);

  return (
    <article className={styles.card}>
      <Link to={href} className={styles.cardLink}>
        <div className={styles.cardMedia}>
          <BlogCover post={promoCoverSource(promo)} className={styles.cardCover} />
          <span className={`${styles.statusPill} ${styles[`pill_${badge.variant}`] || ""}`}>
            {badge.label}
          </span>
        </div>
        <div className={styles.cardBody}>
          <Heading className={styles.cardTitle}>{promo.title}</Heading>
          {promo.prize_name && promo.kind !== "PROMO_INFO" && (
            <p className={styles.cardPrize}>Premio: {promo.prize_name}</p>
          )}
        </div>
        {strip && (
          <div className={styles.cardStrip}>
            <StripText text={strip} />
          </div>
        )}
      </Link>
    </article>
  );
};

export default PromoCard;
